// scrollBehavior:
// - only available in html5 history mode
// - defaults to no scroll behaviour
// - return false to prevent scroll

const originPosition = { x: 0, y: 0 }

export const scrollBehaviour = function (to, from, savedPosition) {
  /*
   * If the resolved position is falsy or an empty object,
   * the route will retain its current scroll position
   *
   * Note: savedPosition is only available for popstate navigations
   * (i.e. browser forward/back buttons)
   *
   */
  const position = {
    ...originPosition,
    ...savedPosition
  }

  console.debug(`[scrollBehaviour]: Routing from "${from.name}" to "${to.name}".`)

  // const element = document.getElementById(scrollableElementId)

  if (savedPosition) {
    console.debug('[scrollBehaviour]: savedPosition=', savedPosition)
  }

  // scroll to anchor by returning the selector
  if (to.hash) {
    // ignore hashtags used as parameters
    if (to.hash.startsWith('#state') || to.hash.startsWith('#code') || to.name === 'splash') {
      return false
    }

    console.debug('[scrollBehaviour]: to.hash=', to.hash)

    // verify the hash
    if (document.querySelector(to.hash)) {
      position.selector = to.hash
      position.behavior = 'smooth'
      position.offset = { x: 0, y: 0 }
    }
  }

  // scroll to top if the route metadata (including child routes) says so
  if (to.matched.some((route) => route.meta?.scrollToTop)) {
    position.x = 0
    position.y = 0
  }

  // scroll to top if on same route
  if (to.name === from.name) {
    position.x = 0
    position.y = 0
  }

  // restore scroll position when returning from an iplayer
  if (from.name === 'iplayer') {
    // restore position from route meta data (see router.afterEach)
    position.x = to.meta?.scrollPosition?.x || 0
    position.y = to.meta?.scrollPosition?.y || 0

    console.debug(
      `[scrollBehaviour]: Restoring scrollPosition[${to.name}]=(${position.x}, ${position.y})`
    )
  }

  return new Promise((resolve) => {
    console.debug(`[scrollBehaviour]: position=(${position.x},${position.y})`)

    // wait for the out transition to complete (if necessary)
    // (triggerScroll event is emitted by AppMain component)
    // (this = $router; this.app.$root = App.vue)
    this.app.$root.$once('triggerScroll', () => {
      console.debug(`[scrollBehaviour]: scrolling to (${position.x},${position.y})`)
      this.app.$nextTick(() => {
        resolve(position)
      })
    })
  })
}
